import styled from 'styled-components/macro';

export const ButtonWrapper = styled.div`
  .cogs-button {
    height: 36px !important;
  }
`;
